// removed by extract-text-webpack-plugin
module.exports = {"Diary":"Diary-cssmodule-Diary-3MyE-"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/Diary.cssmodule.less
// module id = 651
// module chunks = 0